import $ from 'jquery';

export default class HomeInstagram {
  constructor(section) {
    this.$el = $(section.el);
    this.photoContainer = $('[data-instagram-photos]', this.$el);
    this.linkContainer = $('[data-instagram-link]', this.$el);
    this.linkTextContainer = $('[data-instagram-link-text]', this.$el);
    this.accessToken = $('[data-instagram-token]', this.$el).attr('data-instagram-token');
    this.accessTokenError = $('[data-instagram-error]', this.$el).attr('data-instagram-error');

    if (this.$el.length) {
      this.init();
    }
  }

  init() {
    if (this.accessToken.length > 0) {
        this._getPhotos(this.accessToken);
    } else {
        this._hasError(false);
    }
  }

  _getPhotos(accessToken) {
    var url = `https://api.instagram.com/v1/users/self/media/recent?access_token=${this.accessToken}&count=6&callback=`;

    $.ajax({
      type: 'GET',
      dataType: 'jsonp',
      url: url,
      success: (response) => {
        if (response.meta.code == 200) {
          this.photoContainer.html('');

          this.linkContainer.attr('href', `https://instagram.com/${response.data[0].user.username}`);
          this.linkTextContainer.html(response.data[0].user.username);
          this.linkContainer.css('display', 'block');

          var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

          for (var i = 0; i < response.data.length; i++) {
            var d = new Date(response.data[i].created_time * 1000);
            var curr_year = d.getFullYear();
            var curr_Month = months[d.getMonth()].substr(0, 3);
            var curr_date = d.getDate();
            var t = `${curr_Month} ${curr_date}, ${curr_year}`;

            this.photoContainer.append(
              `<a class="instagram-photo-container" target="_blank" href="${response.data[i].link}">
                <div class="instagram-photo"
                style="background-image: url(${response.data[i].images.standard_resolution.url})">
                </div>
                <div class="instagram-overlay">
                  <div class="instagram-overlay-content">
                    <div class="instagram-likes">
                      <svg role="img" class="instagram-heart-icon navigation-social-item-icon">
                        <use xlink:href="#icon-social-heart"></use>
                      </svg>
                      ${response.data[i].likes.count}
                    </div>
                    <div class="instagram-caption">${response.data[i].caption.text}</div>
                    <div class="instagram-date">${t}</div>
                  </div>
                </div>
              </a>`
            );
          }
        } else {
          this._hasError(response);
          this._errorOverlay();
        }
      }
    });
  }

  error(response) {
    this._hasError(response);
  }

  _errorOverlay() {
    return this.photoContainer.find('[data-instagram-error]').length

    this.photoContainer.append(`<div class=\'instagram-error\' data-instagram-error>${this.accessTokenError}</div>`);
    this.errorContainer = this.photoContainer.find('[data-instagram-error]');
  }

  _hasError(response) {
    console.log(`Instagram error: #{response.meta.error_message}`);
  }
}
